export const safeParseJSON = <T>(jsonString: string): T | undefined => {
  try {
    return JSON.parse(jsonString) as T;
  } catch (error) {
    const errorObject = error instanceof Error ? error : new Error("Unknown error");
    console.error("Failed to parse JSON:", errorObject);
    newrelic.noticeError(errorObject);
    return undefined;
  }
};
